const state = {};

const getters = {};

const actions = {
  // eslint-disable-next-line no-empty-pattern
  setSlackToken({}, code) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .post(`/api/integration/slack`, { code })
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  // eslint-disable-next-line no-empty-pattern
  removeSlack({}) {
    return new Promise((resolve, reject) => {
      this._vm.$http
        .delete(`/api/integration/slack`)
        .then(() => {
          resolve();
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  }
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
